import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';

import * as landlordDocumentTemplatesActions from 'actions/landlordDocumentTemplatesActions';
import { getProperties } from 'actions/landlordPropertiesActions';
import { getSignableDocClientId } from 'actions/landlordSignableDocActions';

import { getTranslatedString } from 'helpers/i18n';
import { Loading } from 'components/ui/LoadingIndicator';
import { DocumentTemplateDetailsForm } from './DocumentTemplateDetailsForm';
import { featureEnabled } from 'helpers/ToggleBot';

export const DocumentTemplateDetails = withRouter(
  connect(
    (store) => ({
      properties: store.landlordProperties.properties,
      uploadedFiles: store.landlordDocumentTemplates.uploadedFiles,
      documentTemplate: store.landlordDocumentTemplates.documentTemplate,
      fetchedDocumentTemplateStatus: store.landlordDocumentTemplates.fetchedDocumentTemplateStatus,
      signableDocClientId: store.landlordSignableDoc.clientId,
      updatingDocumentTemplate: store.landlordDocumentTemplates.updatingDocumentTemplate,
      duplicateDocumentTemplateSuccess:
        store.landlordDocumentTemplates.duplicateDocumentTemplateSuccess,
      duplicateDocumentTemplateData: store.landlordDocumentTemplates.duplicateDocumentTemplate,
    }),
    {
      ...landlordDocumentTemplatesActions,
      getProperties,
      getSignableDocClientId,
    }
  )((props) => {
    const {
      documentTemplate,
      uploadedFiles,
      properties,
      getDocumentTemplate,
      updateDocumentTemplate,
      getAllDocumentTemplates,
      params,
      getProperties,
      fetchedDocumentTemplateStatus,
      signableDocClientId,
      updatingDocumentTemplate,
      duplicateDocumentTemplateData,
      duplicateDocumentTemplateSuccess,
      archiveDocumentTemplate,
      duplicateDocumentTemplate,
      deleteDuplicateDocumentTemplate,
      publishDocumentTemplate,
      getSignableDocClientId,
      refreshEditUrlForDocumentTemplate,
    } = props;
    useEffect(() => {
      getAllDocumentTemplates();
      getDocumentTemplate(params.id);
      getProperties({ for_multiselect: true });
      getSignableDocClientId();
    }, [
      params,
      getProperties,
      getDocumentTemplate,
      getSignableDocClientId,
      getAllDocumentTemplates,
    ]);

    useEffect(() => {
      if (!featureEnabled('custom_lease_creator')) {
        browserHistory.push('/companies/dashboard');
      }
    }, []);

    return (
      <div className="body" role="main" style={{ backgroundColor: '#f5f5f9' }}>
        {!properties || fetchedDocumentTemplateStatus === 'pending' ? (
          <Loading
            shouldRender={!documentTemplate || !properties}
            isFullscreen={true}
            text={getTranslatedString('landlordPortal.inspections.loadingText')}
          />
        ) : (
          <DocumentTemplateDetailsForm
            documentTemplate={documentTemplate}
            properties={properties}
            updateDocumentTemplate={updateDocumentTemplate}
            signableDocClientId={signableDocClientId}
            uploadedFiles={uploadedFiles}
            updatingDocumentTemplate={updatingDocumentTemplate}
            duplicateDocumentTemplateData={duplicateDocumentTemplateData}
            duplicateDocumentTemplateSuccess={duplicateDocumentTemplateSuccess}
            archiveDocumentTemplate={archiveDocumentTemplate}
            duplicateDocumentTemplate={duplicateDocumentTemplate}
            deleteDuplicateDocumentTemplate={deleteDuplicateDocumentTemplate}
            publishDocumentTemplate={publishDocumentTemplate}
            refreshEditUrlForDocumentTemplate={refreshEditUrlForDocumentTemplate}
          />
        )}
      </div>
    );
  })
);
